/* ViewContent supplement for curated edition pages only.
 * The EXISTING Shopify custom entry checks consent, then returns the event to
 * this page so the EXISTING native fbq retains the real storefront URL/cookies.
 * Never initialize a second Meta library or intercept native cart submissions.
 */
(() => {
  if (window.chbCommerceReady) return;
  window.chbCommerceReady = true;
  let viewed = false;
  let pending = null;
  const sent = new Set();
  const variants = new Set(['47535033712870', '47547985985766', '47357790028006', '47567965880550']);

  function deliver() {
    if (!pending || typeof window.fbq !== 'function') return;
    const {eventId, variantId, value, currency} = pending;
    if (sent.has(eventId)) { pending = null; return; }
    window.fbq('trackSingle', '1483350446878380', 'ViewContent', {
      content_ids: [variantId], content_type: 'product',
      contents: [{id: variantId, quantity: 1, item_price: value}], value, currency
    }, {eventID: eventId});
    sent.add(eventId);
    pending = null;
  }
  window.addEventListener('message', event => {
    // The Shopify sandbox has an opaque origin. Validate its actual source
    // window, not a wildcard origin or a caller-provided pixel identifier.
    const frame = document.querySelector('iframe[id^="web-pixel-sandbox-CUSTOM-142639334-"]');
    if (!frame || event.source !== frame.contentWindow) return;
    const data = event.data;
    if (data?.type === 'chb:meta-consent-revoked') { pending = null; return; }
    if (data?.type !== 'chb:meta-view' || typeof data.eventId !== 'string' || !data.eventId) return;
    if (!variants.has(data.variantId) || !Number.isFinite(data.value) || data.value < 0 || !/^[A-Z]{3}$/.test(data.currency)) return;
    pending = data;
    deliver();
  });

  function publishView() {
    if (viewed || !window.Shopify?.analytics?.publish) return;
    const source = document.querySelector('[data-chb-offer-view]');
    if (!source) return;
    try {
      const offer = JSON.parse(source.textContent);
      if (!/^\d+$/.test(offer.variantId) || !Number.isFinite(offer.value) || !/^[A-Z]{3}$/.test(offer.currency)) return;
      window.Shopify.analytics.publish('chb:offer_viewed', { ...offer, version: 1 });
      viewed = true;
    } catch (_) { /* Analytics must never prevent a purchase. */ }
  }
  publishView();
  // Shopify's publisher can become available after deferred theme scripts.
  let attempts = 0;
  const timer = setInterval(() => {
    publishView();
    deliver();
    if (++attempts >= 20) clearInterval(timer);
  }, 500);
})();
